<template>
  <div class="icon-selector">
    <div :class="['form-control', 'selected-icon', !disabled && !readonly ? 'clickable' : '']" :readonly="readonly" :disabled="disabled" @click="toggleIcons">
      <div v-if="value">
        <i :class="'nav-icon fa fa-' + value" /> {{ value }}
      </div>
      <div v-else>
        {{ placeholder }}
      </div>
    </div>
    <div v-if="showIcons" class="icons-area">
      <div
        v-for="(icon, index) in icons"
        :key="index"
        v-b-tooltip.hover="true"
        :title="icon"
        :class="{'clickable': true, 'icon-item': true}"
        :icon="icon"
        @click="clickIcon(icon)"
      >
        <i :class="'nav-icon fa fa-' + icon" />
      </div>
    </div>
  </div>
</template>

<script>
import icons from '~/assets/icons.json'

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      inputVal: '',
      showIcons: false,
      icons: icons
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    },
    hasError: function(newVal) {
      this.$forceUpdate()
    }
  },
  methods: {
    clickIcon(icon) {
      if (this.readonly || this.disabled) {
        return
      }
      this.inputVal = icon
      this.toggleIcons()
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
      this.$emit('forceUpdate')
      this.$forceUpdate()
    },
    toggleIcons() {
      if (this.readonly || this.disabled) {
        this.showIcons = false
      } else {
        this.showIcons = !this.showIcons
      }
      this.$nextTick(() => {
        if (this.showIcons) {
          $(this.$el)
            .find('.icons-area')
            .slideDown()
        } else {
          $(this.$el)
            .find('.icons-area')
            .slideUp()
        }
      })
    }
  }
}
</script>

<style scoped>
.icon-selector {
  position: relative;
}
.icons-area {
  display: none;
  background-color: white;
  z-index: 1;
  position: absolute;
  padding: 10px;
  border: 1px solid #999999;
  border-radius: 5px;
  width: 100%;
  height: 300px;
  overflow-y: scroll;
}
.icon-item {
  padding: 10px;
  float: left;
  text-align: center;
  width: 45px;
  height: 45px;
}
.form-control[disabled] {
  background-color: #e4e7ea;
}
.cannot-find {
  display: none;
}
</style>
